import React from "react";
import { CalendarPlus, ListChecks, Star, Vault } from "lucide-react";
import { SidebarLayout } from "@/components/SidebarLayout";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { to: "/", label: "Réserver", icon: CalendarPlus, testid: "nav-reserver", end: true },
  { to: "/mes-courses", label: "Mes courses", icon: ListChecks, testid: "nav-mes-courses" },
  { to: "/coffre", label: "Coffre-fort", icon: Vault, testid: "nav-coffre" },
  { to: "/profil", label: "Adresses favorites", icon: Star, testid: "nav-profil" },
];

export function PatientLayout({ children }) {
  const { user } = useAuth();
  return (
    <SidebarLayout nav={NAV} title={user?.name} subtitle={user?.email}>
      {children}
    </SidebarLayout>
  );
}
